import * as React from "react"
import Button from "@mui/material/Button"
import Grid from "@mui/material/Grid"

import { Box, Drawer } from "@mui/material"
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import RemoveShoppingCartIcon from '@mui/icons-material/RemoveShoppingCart';
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';
import { useTrackedReservationCart } from "./CheckoutState"
import CartItem from "./CartItem"
import { moneyFormat } from "../Utils";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import { useTrackedDarkMode } from "./UserState";

export default function CartDrawer({ open, setCartOpen, reserveStartDate, reserveEndDate, reservation_length, goToCartPage }) {
    const [reservationCart, setReservationCart] = useTrackedReservationCart();
    const [darkMode,] = useTrackedDarkMode();

    const emptyCart = () => {
        setReservationCart({ cart: [], fees_data: {} })
    }
    return (
        (<Drawer variant={"persistent"} anchor="right" open={open} onClose={() => setCartOpen(false)} sx={{ width: '375px', flexShrink: 0 }} slotProps={{
            paper: { variant: "outlined", style: { width: `${375 + 12}px`, top: '72px', backgroundColor: darkMode ? '' : 'white', paddingBottom: '72px' } }
        }}>
            {/* TODO FIX SCROLLBARS OVERLAPPING BETWEEN MAIN BODY AND CART DRAWER */}
            <OverlayScrollbarsComponent defer>
                <Box>
                    <Box sx={{ display: "block" }}>
                        <Button style={{ position: "absolute", right: 5, color: 'black' }} onClick={() => setCartOpen(false)}>Hide</Button>
                    </Box>
                    <h2 style={{ textAlign: 'center' }}><ShoppingCartIcon /> Cart</h2>
                </Box>
                <Box sx={{ pl: 1, pr: 2 }}>
                    <h3 style={{ marginBottom: "5px" }}>Date & Time</h3>
                    <Box>
                        <span>From: {reserveStartDate.format('ddd, MMM D h:mm A')}</span>
                    </Box>
                    <Box>
                        <span>To: {reserveEndDate.format('ddd, MMM D h:mm A')}</span>
                    </Box>
                    <Box>
                        <span><b>{Math.floor((reserveEndDate - reserveStartDate) / 1000 / 60 / 60 / 24) % 7} days, {Math.floor((reserveEndDate - reserveStartDate) / 1000 / 60 / 60) % 24} hrs</b></span>
                    </Box>
                    <h3 style={{ marginBottom: "5px" }}>Payment</h3>
                    <Box>
                        <Grid container columnSpacing={3} justifyContent="flex-start" sx={{ textAlign: 'left' }}>
                            <Grid xs="auto">
                                <Grid container direction="column">
                                    <Grid xs="auto">
                                        <span>Contract Total:</span>
                                    </Grid>
                                    <Grid xs="auto">
                                        <span>Deposit Total:</span>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid xs="auto" sx={{ fontWeight: 'bold' }}>
                                <Grid container direction="column">
                                    <Grid xs="auto">
                                        <span>${moneyFormat(reservationCart.cart.reduce((accumulator, item) => accumulator + item.calculated_posttax_total, 0))}</span>
                                    </Grid>
                                    <Grid xs="auto">
                                        <span>${moneyFormat(reservationCart.cart.reduce((accumulator, item) => accumulator + item.calculated_deposit, 0))}</span>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                    <h3>Items ({reservationCart.cart.length})</h3>
                    {reservationCart.cart.map((item) =>
                    (
                        <CartItem
                            item={item}
                            reservation_length={reservation_length}
                            reserveStartDate={reserveStartDate}
                            reserveEndDate={reserveEndDate}
                        />
                    )
                    )}
                    <Grid container justifyContent="space-between" sx={{ padding: "0px 30px 10px 30px" }}>
                        <Grid xs="auto">
                            <Button variant="outlined" disabled={reservationCart.cart.length === 0} onClick={emptyCart}><RemoveShoppingCartIcon /><Box sx={{ pl: 1 }}>Cancel</Box></Button>
                        </Grid>
                        <Grid xs="auto">
                            <Button variant="contained" disabled={reservationCart.cart.length === 0} onClick={goToCartPage}><ShoppingCartCheckoutIcon /><Box sx={{ pl: 1 }}>Finalize</Box></Button>
                        </Grid>
                    </Grid>
                </Box>
            </OverlayScrollbarsComponent>
        </Drawer>)
    );
}